import React, { useState } from 'react';
import { Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import LoginIcon from '@mui/icons-material/Login';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { UsuarioEstaLogado, UsuarioLogadoGet, UsuarioLogout } from '../../utils/usuarioEstaLogado';
import configUrls from '../../config/configUrls';
import TokenServiceExpired from '../token/TokenServiceExpired';

type Props = {
  sistema: 'site' | 'saber'; // mais seguro
};

function getTempoLogado(dataLogin: string | number | Date) {
  const inicio = new Date(dataLogin).getTime();
  const agora = Date.now();
  const diff = agora - inicio;

  const horas = Math.floor(diff / 1000 / 60 / 60);
  const minutos = Math.floor((diff / 1000 / 60) % 60);

  return `${horas}h ${minutos}m`;
}

export const HeaderUserMenu: React.FC<Props> = ({ sistema }) => {
  const usuarioLogado = UsuarioEstaLogado();
  const token = UsuarioLogadoGet();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  // Escolhe automaticamente a URL conforme o sistema
  const loginUrl = sistema === 'saber' ? configUrls.SABER_LOGIN : configUrls.SITE_LOGIN;

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    UsuarioLogout();
    window.location.href = loginUrl;
  };

  return (
    <>
      {!usuarioLogado ? (
        <Link
          to={loginUrl}
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <IconButton color="inherit" edge="start">
            <LoginIcon />
          </IconButton>
          <Typography variant="button" sx={{ ml: 1 }}>
            Entrar
          </Typography>
        </Link>
      ) : (
        <Box textAlign="center">
          <Tooltip title={`${token.usuario} - ${sistema}`} arrow enterTouchDelay={0} leaveTouchDelay={3000}>
            <IconButton size="large" edge="end" color="inherit" aria-label="menu" sx={{ mr: 2 }} onClick={handleMenuOpen}>
              <AccountCircleIcon />
            </IconButton>
          </Tooltip>

          <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleCloseMenu}>
            {/* Nome do usuário */}
            <MenuItem disabled sx={{ opacity: 1, fontWeight: 'bold' }}>
              {token.usuario}
            </MenuItem>

            {/* --- Bloco setor e trocar setor --- */}
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography variant="subtitle2" fontWeight="bold">
                Setor Atual
              </Typography>

              <Typography variant="body2" color="text.secondary">
                {token.setorNome}
              </Typography>

              <Typography
                variant="body2"
                color="primary"
                sx={{ mt: 1, cursor: 'pointer', fontWeight: 600 }}
                onClick={() => {
                  // ação de trocar setor
                  console.log('Trocar setor clicado');
                }}
              >
                Trocar setor
              </Typography>

              <Divider />

              <Typography
                variant="body2"
                color="primary"
                sx={{ mt: 0.5, cursor: 'pointer', fontWeight: 600 }}
                onClick={() => {
                  console.log('Trocar senha clicado');
                }}
              >
                Trocar senha
              </Typography>
              <Divider />
              <TokenServiceExpired />
            </Box>

            {/* Linha separadora */}
            <Divider />

            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <MeetingRoomIcon />
              </ListItemIcon>
              <Typography variant="body1" color="primary">
                Sair
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      )}
    </>
  );
};
